var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-modal t-lk-modal__content"},[(_vm.props.title)?_c('h2',{staticClass:"t-lk-modal__title"},[_vm._v(_vm._s(_vm.props.title))]):_c('h2',{staticClass:"t-lk-modal__title"},[_vm._v(_vm._s(_vm.$root.staticText.lk.requestTitle))]),_vm._v(" "),_c('CoreForm',{staticClass:"training-modal__form",attrs:{"action":"lk/request","form-config":_vm.form,"submit-label":_vm.props.button},on:{"submit:success":_vm.onSuccessSubmit,"submit:error":_vm.onErrorSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/training.vue?vue&type=template&id=21c50425&
// module id = 1671
// module chunks = 0